import React from 'react';
import styled from 'styled-components';
import { PublicPageLayout } from '../components/PublicPageLayout';

const Section = styled.section`
  background: var(--bg-card);
  border: 1px solid rgba(0, 212, 170, 0.12);
  border-radius: 18px;
  padding: 28px;
  margin-bottom: 20px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.2);
`;

const SectionTitle = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  color: var(--text-muted);
  margin-bottom: 12px;
`;

const List = styled.ul`
  padding-left: 20px;
  color: var(--text-muted);
`;

export const TermsPage: React.FC = () => {
  return (
    <PublicPageLayout
      title="Termos de Uso"
      subtitle="Regras claras para uma parceria transparente e segura."
      eyebrow="Contrato digital"
    >
      <Section>
        <SectionTitle>1. Aceitacao dos Termos</SectionTitle>
        <Paragraph>
          Ao acessar o PontoFiel, voce confirma que leu, entendeu e concorda com estes Termos de Uso.
          Caso nao concorde, interrompa o uso imediatamente.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>2. Cadastro e Conta</SectionTitle>
        <Paragraph>
          Voce e responsavel pelas informacoes fornecidas no cadastro e pela seguranca do seu acesso.
        </Paragraph>
        <List>
          <li>Mantenha seus dados atualizados.</li>
          <li>Proteja suas credenciais e nao compartilhe com terceiros.</li>
          <li>Comunique qualquer uso nao autorizado.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>3. Uso Permitido</SectionTitle>
        <Paragraph>
          O PontoFiel deve ser utilizado somente para fins licitos e dentro do escopo contratado.
        </Paragraph>
        <List>
          <li>Proibido uso para spam ou disparos nao autorizados.</li>
          <li>Proibido tentativa de engenharia reversa, ataque ou fraude.</li>
          <li>Respeite os direitos de propriedade intelectual.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>4. Assinaturas e Pagamentos</SectionTitle>
        <Paragraph>
          Os planos, valores e condicoes podem variar conforme a contratacao e estao descritos no momento da compra.
        </Paragraph>
        <List>
          <li>Pagamentos sao processados por provedores externos seguros.</li>
          <li>O nao pagamento pode levar a suspensao do servico.</li>
          <li>Reembolsos seguem as politicas de cada plano.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>5. Conteudo e Propriedade Intelectual</SectionTitle>
        <Paragraph>
          Todo o conteudo, marcas, layout e tecnologia do PontoFiel sao de propriedade da plataforma.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>6. Limitacao de Responsabilidade</SectionTitle>
        <Paragraph>
          O PontoFiel busca alta disponibilidade, mas nao garante operacao ininterrupta.
          Nao nos responsabilizamos por perdas indiretas decorrentes de uso indevido.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>7. Cancelamento</SectionTitle>
        <Paragraph>
          O cliente pode solicitar cancelamento conforme regras do plano contratado. A plataforma pode suspender contas
          em caso de violacao destes termos.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>8. Atualizacoes</SectionTitle>
        <Paragraph>
          Estes termos podem ser atualizados. Alteracoes relevantes serao comunicadas pelos canais oficiais.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>9. Contato</SectionTitle>
        <Paragraph>
          Duvidas? Entre em contato pela pagina de Contato. Estamos prontos para ajudar.
        </Paragraph>
      </Section>
    </PublicPageLayout>
  );
};
